import type { ReactNode } from 'react'

/**
 * A value that must stay Latin and left-to-right inside Arabic copy: a phone
 * number or calling code, an e-mail address, a reference or ID, a URL.
 * Without the isolate the bidi algorithm reorders "+965 5555 1234" or moves
 * trailing punctuation to the wrong side.
 */
export function Ltr({ children, className }: { children: ReactNode; className?: string }) {
  return <bdi dir="ltr" translate="no" className={className}>{children}</bdi>
}

/**
 * Authored, user or server content that keeps its own language (test titles,
 * names, announcements, generated feedback). `bdi` picks the direction from
 * the content itself, so an English title neither reorders the Arabic around
 * it nor is reordered by it. `data-content` marks it for the Arabic sweep.
 */
export function Content({ children, className }: { children: ReactNode; className?: string }) {
  return <bdi data-content="" className={className}>{children}</bdi>
}
